// Helpers shared by the Rego AI evidence access-request surfaces
// (Checks locked strip, Checks access request block, Controls empty state).

// The API returns an owner's integrations as one comma-joined string.
// Split it back out so each integration can be shown as its own chip.
export const splitIntegrations = (integrations = "") =>
  String(integrations || "")
    .split(",")
    .map((name) => name.trim())
    .filter(Boolean);

export const initials = (nameOrEmail = "") => {
  const source = String(nameOrEmail).trim();
  if (!source) return "?";
  const parts = source.split(/[\s@.]+/).filter(Boolean);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
};
